/**
 * Marks a document as a distractor (used by eval suites — the RAG layer is
 * expected to *not* surface these). Seeded by `npm run embed:distractors`
 * on the backend, never uploaded by admins.
 */
export function DistractorBadge() {
  return (
    <span
      title="Eval-only distractor. The RAG layer is expected to NOT surface this in answers."
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md border border-amber-300 bg-amber-50 text-amber-800 text-[10px] font-semibold uppercase tracking-wide"
    >
      <span aria-hidden="true">⚠</span>
      Distractor
    </span>
  );
}
